import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';

var ArticleWidgetFormattedText = createReactClass({
  propTypes: {
    index: PropTypes.number,
    text: PropTypes.string,
    uuid: PropTypes.string,
    name: PropTypes.string,
    changeObject: PropTypes.func,
    contentSpace: PropTypes.string,
  },

  getDefaultProps: function() {
    return {
      index: 0,
      text: '',
      uuid: '',
      name: '',
      title: '',
      changeObject: function() {},
    };
  },

  getWidgetObject: function() {
    return {
      type: 'text',
      text: this.props.data.text,
      name: this.props.name,
      header: this.props.data.header,
      uuid: this.props.data.uuid,
    };
  },

  didRemoveWidget() {
    this.props.didRemoveWidget(this.props.index);
  },

  addCkeditor(editor) {
    this.props.addCkeditor(this.props.index, editor);
  },

  moveWidgetUp() {
    this.props.moveWidget(this.props.index, 'up');
  },

  moveWidgetDown() {
    this.props.moveWidget(this.props.index, 'down');
  },

  componentDidMount: function() {
    var name = 'ckeditor_' + this.props.index;
    var _this = this;

    window.CKEDITOR.ClassicEditor
      .create(document.querySelector(`#${name}`), {
        plugins: [ window.CKEDITOR.Essentials, window.CKEDITOR.Bold, window.CKEDITOR.Italic, window.CKEDITOR.Font, window.CKEDITOR.Paragraph, window.CKEDITOR.Alignment, window.CKEDITOR.LinkEditing, window.CKEDITOR.ImageUploadEditing, window.CKEDITOR.CloudServices, window.CKEDITOR.ImageUploadProgress,
            window.CKEDITOR.PictureEditing, window.CKEDITOR.CKBox, window.CKEDITOR.BlockQuote, window.CKEDITOR.CKBoxEditing, window.CKEDITOR.CodeBlock, window.CKEDITOR.List, window.CKEDITOR.TodoList, window.CKEDITOR.Indent, window.CKEDITOR.StrikethroughUI, window.CKEDITOR.StrikethroughEditing,
            window.CKEDITOR.SubscriptEditing, window.CKEDITOR.SubscriptUI, window.CKEDITOR.SuperscriptEditing, window.CKEDITOR.SuperscriptUI, window.CKEDITOR.UnderlineEditing, window.CKEDITOR.UnderlineUI, window.CKEDITOR.Code, window.CKEDITOR.Heading, window.CKEDITOR.Link, window.CKEDITOR.LinkImage,
            window.CKEDITOR.ImageBlockEditing, window.CKEDITOR.CKBoxImageEdit, window.CKEDITOR.Image, window.CKEDITOR.ImageBlock, window.CKEDITOR.ImageInline, window.CKEDITOR.Base64UploadAdapter, window.CKEDITOR.Table, window.CKEDITOR.TableSelection,
            window.CKEDITOR.TableToolbar, window.CKEDITOR.TableProperties, window.CKEDITOR.TableCellProperties, window.CKEDITOR.SimpleUploadAdapter, window.CKEDITOR.HtmlEmbed, window.CKEDITOR.GeneralHtmlSupport, window.CKEDITOR.FullPage, window.CKEDITOR.FindAndReplace, window.CKEDITOR.HorizontalLine, window.CKEDITOR.ImageInsert,
            window.CKEDITOR.MediaEmbed, window.CKEDITOR.RemoveFormat, window.CKEDITOR.SelectAll, window.CKEDITOR.SpecialCharacters, window.CKEDITOR.SpecialCharactersEssentials, window.CKEDITOR.ImageToolbar, window.CKEDITOR.ContextualBalloon, window.CKEDITOR.DecoupledEditor,
            window.CKEDITOR.ImageStyle, window.CKEDITOR.ImageResize, window.CKEDITOR.Style, window.CKEDITOR.Autosave],
        toolbar: {items: [
            'undo', 'redo',
            '|',
            'heading',
            '|',
            'style',
            '|',
            'findAndReplace', 'horizontalLine',
            '|',
            'fontfamily', 'fontsize', 'fontColor', 'fontBackgroundColor',
            '|',
            'bold', 'italic', 'strikethrough', 'subscript', 'superscript', 'underline', 'code',
            '|',
            'link', 'blockQuote', 'codeBlock',
            '|',
            'bulletedList', 'numberedList', 'todoList', 'outdent', 'indent',
            '|',
            'alignment',
            '|',
            'insertImage', 'imageTextAlternative', 'mediaEmbed',
            '|',
            'insertTable',
            '|',
            'removeFormat', 'selectAll', 'specialCharacters'
          ],
          shouldNotGroupWhenFull: true
        },
        table: {
          contentToolbar: [
            'tableColumn', 'tableRow', 'mergeTableCells',
            'tableProperties', 'tableCellProperties'
          ],
        },
        heading: {
          options: [
            { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
            { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
            { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' }
          ]
        },
        link: {
          decorators: {
            // odkazy na PDF sa na webe otvoria v novom tabe
            openPdfInNewTab: {
              mode: 'automatic',
              callback: url => /\.pdf($|[?#])/i.test(url || ''),
              attributes: {
                target: '_blank',
                rel: 'noopener noreferrer',
              },
            },
          },
        },
        fontColor: {
          colorPicker: {
            format: 'hex'
          }
        },
        image: {
          toolbar: [
            'imageStyle:inline',
            'imageStyle:block',
            'imageStyle:side',
            '|',
            'toggleImageCaption',
            'imageTextAlternative',
            '|',
            'linkImage'
          ],
          insert: {
            type: 'auto'
          }
        },
        style: {
          definitions: [
            {
              name: 'Citácia s úvodzovkami',
              element: 'span',
              classes: ['styled-quote'],
              attributes: {
                title: 'Citácia'
              }
            }
          ]
        },
      })
      .then(editor => {
        _this.editorInstance = editor;
        this.props.ckeditors[this.props.index] = editor;

        editor.setData(this.props.data.text || '');

        editor.model.document.on('change:data', () => {
          const content = editor.getData();
          _this.onChangeContent(content);
        });
      })
      .catch(error => {
        console.error('CKEditor 5 initialization failed:', error);
      });
  },

  componentDidUpdate: function() {
    var _this = this;

    if (this.props.needsUpdate) {
      _this.props.contentOfEditors.forEach((content, index) => {
        const editor = _this.props.ckeditors[index];

        if (content == null && editor) {
          editor.destroy();
          _this.props.ckeditors[index] = null;
        } else if (content !== null && editor) {
          editor.setData(content);
        } else if (content !== null && !editor) {
          //zatial nic, nemalo by nastat
        }
      });
      _this.props.turnOffNeedsUpdate();
    }
  },

  onChangeContent: function(content) {
    var object = this.getWidgetObject();
    object.text = content;
    this.props.contentOfEditors[this.props.index] = content;
    this.props.changeObject(this.props.index, object);
  },

  onChangeName: function(event) {
    var value = event.target.value;
    var object = this.getWidgetObject();
    object.header = value;
    this.props.changeObject(this.props.index, object);
  },

  render: function() {
    return (
      <div
        data-index={this.props.index}
        style={{ clear: 'both' }}
        className="panel panel-default widget-body"
      >
        <div className="panel-heading">
          <div className="btn-group">
            <button
              className="btn btn-default btn-sm"
              onClick={this.moveWidgetUp}
              disabled={this.props.index === 0}
            >
              <i className="fa fa-arrow-up" />
            </button>
            <button
              className="btn btn-default btn-sm"
              onClick={this.moveWidgetDown}
              disabled={this.props.isLast}
            >
              <i className="fa fa-arrow-down" />
            </button>
          </div>
          <span className="panel-title">
            <strong> {this.props.name}</strong>
          </span>
          <a
            onClick={this.didRemoveWidget}
            href="javascript:void(0);"
            className="btn btn-danger btn-sm pull-right"
          >
            <i className="fa fa-times" />
          </a>
        </div>
        <div className="panel-body">
          <input
            onChange={this.onChangeName}
            value={this.props.data.header}
            type="text"
            placeholder="Nadpis textového bloku"
            className="form-control"
            name="widget-text"
          />
          <textarea
            placeholder=""
            rows="10"
            cols=""
            className="form-control"
            id={'ckeditor_' + this.props.index}
            name="text"
          />
        </div>
      </div>
    );
  },
});

export default ArticleWidgetFormattedText;



// WEBPACK FOOTER //
// ./src/js/app/cm/components/ArticleWidgets/ArticleWidgetFormattedText.jsx